export function RotateRightFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M10.8 2.6a.5.5 0 00-.8.4v1c-.049 0-.098.004-.148.011-4.353.65-7.497 4.75-6.841 9.137a1 1 0 001.978-.296c-.48-3.212 1.795-6.277 5.01-6.839V7a.5.5 0 00.8.4l2.668-2a.5.5 0 000-.8l-2.667-2z"
      ></path>
      <path fill="currentColor" d="M10 9a3 3 0 00-3 3v6a3 3 0 003 3h8a3 3 0 003-3v-6a3 3 0 00-3-3h-8z"></path>
    </svg>
  );
}
